import { render } from "./classlearntask.vue?vue&type=template&id=6986a742&scoped=true&ts=true"
import script from "./classlearntask.vue?vue&type=script&lang=ts"
export * from "./classlearntask.vue?vue&type=script&lang=ts"

import "./classlearntask.vue?vue&type=style&index=0&id=6986a742&lang=scss&scoped=true"
import "./classlearntask.vue?vue&type=style&index=1&id=6986a742&lang=css"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6986a742"]])

export default __exports__